import IconWrapper from "@components/svg_icon_wrapper"

export default function AutomationOutlined() {
  return (
    <IconWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.009"
        height="24.016"
        viewBox="0 0 30.076 38.662"
      >
        <g id="__TEMP__SVG__" transform="translate(1.108 -1.072) rotate(11)">
          <path
            id="Path_4724"
            data-name="Path 4724"
            d="M24.626.148a1.086,1.086,0,0,1,.493,1.259L21.208,14.113h7.215a1.086,1.086,0,0,1,.79,1.831L11.844,34.4a1.086,1.086,0,0,1-1.828-1.064l3.91-12.708H6.711A1.086,1.086,0,0,1,5.92,18.8L23.291.341A1.086,1.086,0,0,1,24.626.146Z"
            fill="#fff"
            fillRule="evenodd"
          />
        </g>
      </svg>
    </IconWrapper>
  )
}
